import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
  Font,
  Link,
  
} from "@react-pdf/renderer";

import imgKkp from "../../assets/img/logo-kkp.png";
import srcArial from "../../assets/font/arial/arial.ttf";
import srcArialBold from "../../assets/font/arial/ARIBL0.ttf";
import scheduleService from "services/report/scheduleService";

// REGISTER FONT (GLOBAL, SEKALI)
Font.register({ family: "Arial", src: srcArial });
Font.register({ family: "Arial-Bold", src: srcArialBold });
Font.registerHyphenationCallback(word => [word]);


// =====================
// STYLES
// =====================
const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    paddingBottom: 30,
    paddingHorizontal: 42,
    fontFamily: "Arial",
    fontSize: 11,
  
  },

    row: {
      flexDirection: "row",
      alignItems: "flex-start",
    },

  center: { textAlign: "center" },

  bold: { fontFamily: "Arial-Bold" },

  logo: { width: 120, height: 120 },

  headerLine: {
    borderBottomWidth: 2,
    borderBottomColor: "#000",
    marginBottom: 6,
    paddingBottom: 4,
  },

  section: { marginBottom: 3 },

  labelCol: { width: "16%" },
  colonCol: { width: "2%" },
  numberCol: { width: "4%" },
  contentCol: {
    width: "80%",
    textAlign: "justify",
    lineHeight: 0.8,
  },

  tableHeader: {
    borderWidth: 1,
    borderColor: "#000",
    padding: 4,
    fontFamily: "Arial-Bold",
    textAlign: "center",
  },

  cell: {
    borderBottomWidth: 1,
    borderRightWidth: 1,
    borderColor: "#000",
    padding: 4,
    minHeight: 22,
    textAlign: "center",
    justifyContent: "center",
  },
  justifyIndent: {
    textAlign: "justify",
    textIndent: 20,
    lineHeight: 1.4,
  },
  penutup: {
    marginTop: 1,
    textAlign: "justify",
    lineHeight: 1.4,
  },

  footerRow: {
    marginTop: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },

  kknBox: {
    marginTop: 10,
    width: "55%",
    borderWidth: 1,
    padding: 8,
  },

  kknText: {
    fontSize: 9,
    textAlign: "center",
    fontFamily: "Arial-Bold",
    lineHeight: 1.4,
    textAlign: "justify", 
  },

  ttd: {
    width: "40%",
    alignItems: "left",
  },

  jabatanText: {
    marginTop: 5,
  },

  namaPejabat: {
    marginTop: 50,
      },

  fieldRow: {
  flexDirection: "row",
  alignItems: "flex-start",
},

fieldLabel: {
  width: 45, // samakan semua label
},

fieldColon: {
  width: 6,
},

fieldValue: {
  flex: 1,
},


});
const formatTanggal = (tanggal) => {
  if (!tanggal) return "";
  return new Date(tanggal).toLocaleDateString("id-ID", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

const STskp = ({ data }) => {
  if (!data) return null;

  const {
    no_surat,
    tanggal_surat,
    pejabat_ttd,
    jadwal = [],
  } = data;

  const jadwalUtama = jadwal[0] || {};
  const personil = jadwalUtama.personil || [];


  return (
    <Document>
      {/* ================= PAGE 1 ================= */}
      <Page size="A4" style={styles.page}>
        {/* HEADER */}
        <View style={[styles.row, styles.headerLine]}>
          <Image src={imgKkp} style={styles.logo} />
          <View style={{ flex: 1, alignItems: "center" }}>
            <Text style={[styles.bold, { fontSize: 14, color: "#7895be" }]}>
              KEMENTERIAN KELAUTAN DAN PERIKANAN
            </Text>
            <Text style={{  fontSize: 13, color: "#7895be" }}>
              BADAN PENGENDALIAN DAN PENGAWASAN MUTU
            </Text>
            <Text style={{  fontSize: 13, color: "#7895be" }}>
              HASIL KELAUTAN DAN PERIKANAN
            </Text>
            <Text style={[styles.bold, { fontSize: 12, color: "#7895be" }]}>
              BALAI PENGENDALIAN DAN PENGAWASAN MUTU,
            </Text>
            <Text style={[styles.bold, { fontSize: 12, color: "#7895be" }]}>
              DAN KEAMANAN HASIL PERIKANAN JAKARTA I
            </Text>
            <Text style={{  fontSize: 11, color: "#000000ff" }}>
              GEDUNG KARANTINA PERTANIAN BANDARA SOEKARNO-HATTA 19120  
            </Text>
            <Text style={{  fontSize: 11, color: "#000000ff" }}>
              TELEPON (021) 5507932, 22566785 FAKSIMILE (021) 5506738  
            </Text>
            <Text style={{  fontSize: 11, color: "#000000ff" }}>
                LAMAN{" "}
                <Link 
                    src="https://www.kkp.go.id" 
                    style={{ color: "blue", textDecoration: "underline" }}
                >
                    www.kkp.go.id
                </Link>
                {" "} SURAT ELEKTRONIK {" "}
                <Link 
                    src="JakartaI@bkipm.kkp.go.id" 
                    style={{ color: "blue", textDecoration: "underline" }}
                >
                    jakartaI@bkipm.kkp.go.id
                </Link>
            </Text>
          </View>
        </View>

        {/* JUDUL */}
        <View style={styles.section}>
          <Text style={[styles.center]}>SURAT TUGAS INI SURAT TUGAS SKP</Text>
          <Text style={styles.center}>
           Nomor: {no_surat}
          </Text>
        </View>

        {/* MENIMBANG */}
        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.labelCol}>Menimbang</Text>
            <Text style={styles.colonCol}>:</Text>
            <Text style={styles.numberCol}></Text>
            <Text style={styles.contentCol}>
              Bahwa dalam rangka Survailen Penerapan Sistem HACCP dan Pengambilan
              Sampel Official Control pada Unit Pengolahan Ikan
            </Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.labelCol}>Dasar</Text>
            <Text style={styles.colonCol}>:</Text>
            <Text style={styles.numberCol}></Text>
            <Text style={styles.contentCol}>
              Daftar Isian Pelaksanaan Anggaran Stasiun Karantina Ikan, Pengendalian Mutu,
              dan Keamanan Hasil Perikanan Merak TA. 2025. Segala biaya yang timbul
              berkaitan dengan pelaksanaan tugas dibebankan pada anggaran masing-masing
              Unit Kerja sesuai Inpektur Mutu bertugas
            </Text>
          </View>
        </View>

       {personil.map((item, index) => (
        <View key={index} style={styles.row}>
          {/* Kolom "Kepada :" hanya muncul di baris pertama */}
          <Text style={styles.labelCol}>
            {index === 0 ? "Kepada" : ""}
          </Text>
          <Text style={styles.colonCol}>
            {index === 0 ? ":" : ""}
          </Text>

          {/* Nomor urut */}
          <Text style={styles.numberCol}>{index + 1}.</Text>

          <View style={styles.contentCol}>
            <View style={styles.fieldRow}>
              <Text style={styles.fieldLabel}>Nama</Text>
              <Text style={styles.fieldColon}>:</Text>
              <Text style={styles.fieldValue}>
                {item.nama} ({index === 0 ? "Ketua" : "Anggota"})
              </Text>
            </View>

            <View style={styles.fieldRow}>
              <Text style={styles.fieldLabel}>NIP</Text>
              <Text style={styles.fieldColon}>:</Text>
              <Text style={styles.fieldValue}>{item.nip}</Text>
            </View>

            <View style={styles.fieldRow}>
              <Text style={styles.fieldLabel}>No REG</Text>
              <Text style={styles.fieldColon}>:</Text>
              <Text style={styles.fieldValue}>{item.noReg}</Text>
            </View>
          </View>
        </View>
      ))}


        <View style={[styles.row, { marginTop: 2}]}>
          <Text style={styles.labelCol}>Untuk</Text>
          <Text style={styles.colonCol}>:</Text>
          <Text style={styles.numberCol}>a.</Text>
          <View style={styles.contentCol}>
            <Text>Melaksanakan Survailen Penerapan Sistem HACCP dan Pengambilan Sampel Official Control pada Unit Pengolahan Ikan ke {jadwalUtama.NM_UPI} di {jadwalUtama.ALAMAT} pada tanggal {formatTanggal(jadwalUtama.TANGGAL)};</Text>
          </View>
        </View>
        <View style={styles.row}>
          <Text style={styles.labelCol}></Text>
          <Text style={styles.colonCol}></Text>
          <Text style={styles.numberCol}>b.</Text>
          <View style={styles.contentCol}>
            <Text>Membuat laporan tertulis pelaksanaan tugas hasil Survailen Penerapan Sistem HACCP dan Pengambilan Sampel Official Control pada Unit Pengolahan Ikan
               dan melaporkan kepada Kepala Balai Besar KIPM Jakarta I, Badan  Karantina Ikan, Pengendalian Mutu  dan Keamanan Hasil Perikanan (BKIPM) 
               sesuai ruang  lingkup produk  yang  disurvailen;</Text>
          </View>
        </View>
        <View style={styles.row}>
          <Text style={styles.labelCol}></Text>
          <Text style={styles.colonCol}></Text>
          <Text style={styles.numberCol}>c.</Text>
          <View style={styles.contentCol}>
            <Text>Apabila pada saat  Survailen Penerapan Sistem HACCP dan Pengambilan Sampel Official Control pada Unit Pengolahan Ikan terdapat ruang lingkup produk yang  tidak  ada kegiatan proses, 
              maka ruang lingkup produk tersebut akan  diverifikasi  oleh  Inspektur  Mutu Balai Besar KIPM Jakarta I 
              dan selanjutnya dilaporkan  kepada  Kepala  Balai  Besar KIPM Jakarta I;</Text>
          </View>
        </View>
        <View style={styles.row}>
          <Text style={styles.labelCol}></Text>
          <Text style={styles.colonCol}></Text>
          <Text style={styles.numberCol}>d.</Text>
          <View style={styles.contentCol}>
            <Text>Inspektur Mutu tidak diperkenankan menerima sesuatu dari yang  akan  berpengaruh terhadap hasil Survailen Penerapan Sistem HACCP dan Pengambilan Sampel Official Control pada Unit Pengolahan Ikan.</Text>
          </View>
        </View>

        {/* PENUTUP */}
        <Text style={styles.penutup}>
          Demikian Surat Tugas ini dibuat untuk dilaksanakan dengan sebaik-baiknya dan penuh tanggung jawab.
        </Text>


        {/* TTD */}
        <View style={styles.footerRow}>
        {/* KOTAK KKN */}
        <View style={styles.kknBox}>
          <Text style={styles.kknText}>
            Terima kasih untuk tidak memberikan sesuatu atau janji yang dapat mengakibatkan KKN, gratifikasi, dan benturan kepentingan
          </Text>
        </View>

        {/* TANDA TANGAN */}
        <View style={styles.ttd}>
          <Text>
           Jakarta, {formatTanggal(tanggal_surat)}
          </Text>

          <Text style={styles.jabatanText}>
           Plt. Kepala 
          </Text>

          <Text style={styles.namaPejabat}>
            {pejabat_ttd}
          </Text>
        </View>
      </View>
        <View >
          <Text style={{fontSize : 7}} >
            Tembusan
          </Text>

          {[ 
            "Kepala Badan Pengendalian dan Pengawasan Mutu Hasil Kelautan dan Perikanan",
            "Kepala Pusat Pengendalian dan Pengawasan Mutu Pascapanen",
          ].map((item, index) => (
            <View
              key={index}
              style={{ fontSize: 7, flexDirection: "row", }}
            >
              <Text style={{ width: 14 }}>
                {index + 1}.
              </Text>
              <Text style={{ flex: 1 }}>
                {item}
              </Text>
            </View>
          ))}
        </View>

      </Page>
      
    </Document>
  );
};

export default STskp;
